<script lang="ts">
	import type { Connector, Spot } from '$lib/components/pois/types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { connectorTypeToIconNameMap, DIVIDER_FOR_W_TO_KW } from '$lib/components/pois/constants';
	import * as m from '$paraglide/messages';

	interface Props {
		spotsCount: number;
		connectors: Connector[];
	}

	const { spotsCount, connectors }: Props = $props();
	const translation = spotsCount === 1 ? m.ev_spots__one() : m.ev_spots__many({ count: spotsCount });
	// TO DO : for now, we don't have the EVPaymentMethodId for the cash payments because it's not in the static data
	// don't forget to add it when it will be available

	function getMaxChargingPowerInKW(spots: Spot[]) {
		const hasOneValue = spots.length === 1;

		const max = hasOneValue
			? spots[0].power / DIVIDER_FOR_W_TO_KW
			: Math.max(...spots.map(spot => spot.power)) / DIVIDER_FOR_W_TO_KW;

		return hasOneValue
			? m.poi_card__charging_power__one({ count: max })
			: m.poi_card__charging_power__many({ count: max });
	}

	const countOfConnectorsMoreThan3 = $derived(connectors.length > 3 ? connectors.length - 3 : 0);
	const connectorsToShow = $derived(connectors.length ? connectors.slice(0, 3) : []);
</script>

<div class="text-sm">
	{#if spotsCount > 0}
		<div class="flex justify-start items-center p-2 bg-electric-weakest text-coloredneutral rd-2">
			{translation}
		</div>
	{/if}
	{#if connectorsToShow.length > 0}
		<ul class="m-0 p-0 pt-2 flex flex-col gap-y-1">
			{#each connectorsToShow as connector (connector.type)}
				<li class="flex justify-start items-center flex-self-revert text-coloredneutral-soft gap-x-1">
					<Icon icon={connectorTypeToIconNameMap[connector.type]} ariaLabel={connector.name} class="h-5 w-5" />
					<div class="flex flex-col justify-center items-start">
						<span class="font-600">{connector.name}</span>
						<span class="text-coloredneutral-softest">{getMaxChargingPowerInKW(connector.spots)}</span>
					</div>
					<Badge color="connector" isSquare text={`${connector.count}`} size="sm" class="ml-auto" />
				</li>
			{/each}
		</ul>
	{/if}
	{#if countOfConnectorsMoreThan3}
		<div class="text-sm text-primary-weak">
			{m.poi_card__count_more_than_3_connectors({ count: countOfConnectorsMoreThan3 })}
		</div>
	{/if}
</div>
